import React, { useEffect, useState } from "react";
import { t } from "i18next";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { FiUploadCloud } from "react-icons/fi";
import { notifyError, notifySuccess } from "../../utils/toast";


const Uploader = ({
  setImageUrl,
  imageUrl,
  is_multiple,
  no_of_image,
  folder,
  name_merge,
  onImageUpload,
  acceptType
}) => {
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  
  const authToken = adminInfo?.token;
  const accessToken = localStorage.getItem("authkey");
  const [files, setFiles] = useState([]);
  const [, setLoading] = useState(false);
  const [, setError] = useState("");

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: acceptType ? acceptType : "image/jpeg, image/jpg, image/png",
    multiple: is_multiple,
    maxSize: 155000,
    maxFiles: no_of_image || 2,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  useEffect(() => {
    if (fileRejections && fileRejections.length > 0) {
      fileRejections.forEach(({ file, errors }) => {
        errors.forEach((error) => {
          if (error.code === "file-too-large") {
            notifyError(`File exceeds the maximum size of 150KB.`);
          } else if (error.code === "too-many-files") {
            notifyError(`Maximum ${no_of_image || 2} images can be uploaded.`);
          } else {
            notifyError(
              `Error uploading file "${file.path}": ${error.message}`
            );
          }
        });
      });
    }
    if (files && files.length > 0) {
      const imageUrlCount = Array.isArray(imageUrl)
        ? imageUrl.length
        : imageUrl
        ? 1
        : 0;
      if (is_multiple === true && imageUrlCount + files?.length > no_of_image) {
        return notifyError(
          `Maximum ${no_of_image ? no_of_image : 2} Image Can be Upload!`
        );
      }

      setLoading(true);
      setError("Uploading....");
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append("file", file);
      });
      formData.append("folderName", folder);
      formData.append("name_merge", name_merge);

      // for (var key of formData.entries()) {
      //   // console.log(key[0] + ', ' + key[1]);
      // }

      axios({
        url:
          process.env.REACT_APP_API_BASE_URL +
          "/upload/" +
          (files.length === 1 ? "upload-single" : "upload-multiple") +
          "/" +
          name_merge +
          "/" +
          folder,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`,
          accesstoken: accessToken,
        },
        data: formData,
      })
        .then((res) => {
          notifySuccess("Image Uploaded successfully!");
          setLoading(false);
          if (res && res.data.message !== "") {
            if (files.length > 1) {
              setImageUrl(res.data.image_path);
            } else {
              setImageUrl(res.data.image_path);
            }
            if (onImageUpload) {
              onImageUpload(res.data.image_path); // Callback to send the image path back
            }
          }
        })
        .catch((err) => {
          console.error("err", err);
          notifyError(err.Message);
          setLoading(false);
        });
    }
     // eslint-disable-next-line 
  }, [files]);

  // const thumbs = files.map((file) => (
  //   <div key={file.name}>
  //     <div>
  //       <img
  //         className="inline-flex border-2 border-gray-100 w-24 max-h-24"
  //         src={file.preview}
  //         alt={file.name}
  //       />
  //     </div>
  //   </div>
  // ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  // const handleRemoveImage = async (img) => {
  //   const segments = img.split("/");
  //   const imageName = segments[segments.length - 1];
  //   const image_path = `${folder}/${imageName}`;
  //   axios({
  //     url: process.env.REACT_APP_API_BASE_URL + "/upload/delete",
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: { image_path },
  //   })
  //     .then((res) => {
  //       setLoading(false);
  //       notifyError(
  //         res.data.data === "ok" ? "Image deleted successfully!" : res.data.data
  //       );

  //       if (
  //         (is_multiple === true && files.length > 1) ||
  //         (Array.isArray(imageUrl) && imageUrl.length > 1)
  //       ) {
  //         const result = imageUrl?.filter((i) => i !== image_path);
  //         setImageUrl(result);
  //       } else if (
  //         is_multiple === true &&
  //         (files.length === 1 || Array.isArray(imageUrl))
  //       ) {
  //         setImageUrl([]);
  //       } else {
  //         setImageUrl("");
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("err", err);
  //       notifyError(err.Message);
  //       setLoading(false);
  //     });
  // };

  return (
    <div className="w-full text-center">
      {/* Conditional Rendering for Drag-and-Drop Area */}
      {!(
        (is_multiple &&
          (files.length > 0 ||
            (Array.isArray(imageUrl) && imageUrl.length > 0))) ||
        (!is_multiple && (imageUrl || files.length > 0))
      ) && (
        <div
          className="border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer px-6 pt-5 pb-6"
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <span className="mx-auto flex justify-center">
            <FiUploadCloud className="text-3xl text-green-500" />
          </span>
          <p className="text-sm mt-2">{t("DragYourImage")}</p>
          <em className="text-xs text-gray-400">{t("imageFormat")}</em>
        </div>
      )}
      <div className="mt-4 text-xs text-gray-500">
        <p>Max file size: 150 KB.</p>
      </div>
    </div>
  );
};

export default Uploader;